import { useState } from "react";
import { Button, Col, Stack } from "react-bootstrap";
import useOrder from "../../../context/OrderContext";
import TextField from "../../designSystem/TextField";
import TextFieldWithIcon from "../../designSystem/TextFieldWithIcon";

const safeCalculation = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
};


const PricingComponent = () => {
    const { pricingResult } = useOrder();
    const [priceShow, setPriceShow] = useState(false);
    const grossPrice = safeCalculation(pricingResult?.data?.rate);
    const accessorialSurcharge = safeCalculation(pricingResult?.data?.accessorialSurcharge)
    const fuelSurchargeRate = safeCalculation(pricingResult?.data?.fuelSurcharge)
    const rate = safeCalculation(pricingResult?.data?.rate);
    const totalPrice = grossPrice;
    const ChargeableWeight = pricingResult?.data?.totalChargeableWeight || 0;

    const Priceshowhandler = () => {
        setPriceShow(priceShow => !priceShow)
    }

    return (
        <>
            <Col sm={12} className="mb-2">
                <TextFieldWithIcon readOnly icon="$" placeholder="Gross Price" name="rate" value={rate} />
            </Col>
            <Col sm={12}>
                <Button variant="primary" onClick={Priceshowhandler}>View Price Details</Button>
            </Col>
            {
                priceShow ?
                    <Stack className="gap-2 mt-2">
                        <TextFieldWithIcon icon="$" readOnly placeholder="Accessorial" name="accessorial" value={accessorialSurcharge} />
                        <TextFieldWithIcon icon="$" readOnly placeholder="Fuel Surcharge" name="Fuelsurcharge" value={fuelSurchargeRate} />
                        <TextFieldWithIcon icon="$" readOnly placeholder="Total Price" name="TotalQuote" value={totalPrice} />
                        <TextField readOnly label="Chargeable Weight" name="ChargeableWeight" value={ChargeableWeight} />
                    </Stack>
                    :
                    null
            }
        </>
    )
}

export default PricingComponent;